/**
 * Portfolio kérdőív komponens
 *
 * @author Erik Bánhalmi 2017.05.15.
 */
import portfolioQuizTemplate from './portfolio-quiz.pug';

const MODULE_NAME = 'portfolioQuiz';
class PortfolioQuizController {
	constructor() {
		'ngInject';
		this.result = 0;
	}

	submitQuiz() {
		this.expertValue = this.quizModel.expert ? parseInt(this.quizModel.expert, 10) : 2;
		this.result = (parseInt(this.quizModel.savingsAmount, 10) + parseInt(this.quizModel.risk, 10) + parseInt(this.quizModel.riskReaction, 10)) * this.expertValue + 24 * (parseInt(this.quizModel.age, 10) + parseInt(this.quizModel.savingTime, 10));
		if (this.result <= 80) {
			this.portfolio = 'kockazatkerulo';
		} else if (this.result <= 105) {
			this.portfolio = 'klasszikus';
		} else if (this.result <= 130) {
			this.portfolio = 'ovatos';
		} else if (this.result <= 200) {
			this.portfolio = 'kiegyensulyozott';
		} else if (this.result <= 250) {
			this.portfolio = 'novekedesi';
		} else {
			this.portfolio = 'dinamikus';
		}
		this.scrollToTop();
	}
	scrollToTop() {
		let documentElement = angular.element(document);
		let toScroll = document.getElementById('main');
		let bodyElemenet = documentElement.find('body');
		bodyElemenet[0].scrollTop = toScroll.offsetTop;
	}

}


export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: PortfolioQuizController,
		template: portfolioQuizTemplate(),
		bindings: {
			portfolioPageUrl: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/portfolio-quiz/portfolio-quiz.js